import { render, staticRenderFns } from "./OrthoOverview.vue?vue&type=template&id=040b1b11&scoped=true&"
import script from "./OrthoOverview.vue?vue&type=script&lang=ts&"
export * from "./OrthoOverview.vue?vue&type=script&lang=ts&"
import style0 from "./OrthoOverview.vue?vue&type=style&index=0&id=040b1b11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040b1b11",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('040b1b11')) {
      api.createRecord('040b1b11', component.options)
    } else {
      api.reload('040b1b11', component.options)
    }
    module.hot.accept("./OrthoOverview.vue?vue&type=template&id=040b1b11&scoped=true&", function () {
      api.rerender('040b1b11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboards/OrthoOverview.vue"
export default component.exports